export const STATE_NAME_TO_ABBR: Record<string, string> = {
  Alabama: 'AL',
  Alaska: 'AK',
  Arizona: 'AZ',
  Arkansas: 'AR',
  California: 'CA',
  Colorado: 'CO',
  Connecticut: 'CT',
  Delaware: 'DE',
  Florida: 'FL',
  Georgia: 'GA',
  Hawaii: 'HI',
  Idaho: 'ID',
  Illinois: 'IL',
  Indiana: 'IN',
  Iowa: 'IA',
  Kansas: 'KS',
  Kentucky: 'KY',
  Louisiana: 'LA',
  Maine: 'ME',
  Maryland: 'MD',
  Massachusetts: 'MA',
  Michigan: 'MI',
  Minnesota: 'MN',
  Mississippi: 'MS',
  Missouri: 'MO',
  Montana: 'MT',
  Nebraska: 'NE',
  Nevada: 'NV',
  'New Hampshire': 'NH',
  'New Jersey': 'NJ',
  'New Mexico': 'NM',
  'New York': 'NY',
  'North Carolina': 'NC',
  'North Dakota': 'ND',
  Ohio: 'OH',
  Oklahoma: 'OK',
  Oregon: 'OR',
  Pennsylvania: 'PA',
  'Rhode Island': 'RI',
  'South Carolina': 'SC',
  'South Dakota': 'SD',
  Tennessee: 'TN',
  Texas: 'TX',
  Utah: 'UT',
  Vermont: 'VT',
  Virginia: 'VA',
  Washington: 'WA',
  'West Virginia': 'WV',
  Wisconsin: 'WI',
  Wyoming: 'WY',
  'District of Columbia': 'DC',
  'Puerto Rico': 'PR',
  'Virgin Islands': 'VI',
  Guam: 'GU',
  'American Samoa': 'AS',
  'Northern Mariana Islands': 'MP',
  'Armed Forces Americas': 'AA',
  'Armed Forces Europe': 'AE',
  'Armed Forces Pacific': 'AP',
}

const STATE_NAME_TO_ABBR_LOWER: Record<string, string> = Object.fromEntries(
  Object.entries(STATE_NAME_TO_ABBR).map(([k, v]) => [k.toLowerCase(), v]),
)

export const normalizeState = (state: string | null | undefined): string | null => {
  if (!state) return null
  if (state.length === 2) return state.toUpperCase()
  return STATE_NAME_TO_ABBR_LOWER[state.toLowerCase()] || state
}

export const isValidState = (state: string | null | undefined): boolean => {
  if (!state) return true
  if (state.length === 2) {
    const upperState = state.toUpperCase()
    return Object.values(STATE_NAME_TO_ABBR).includes(upperState)
  }
  return state.toLowerCase() in STATE_NAME_TO_ABBR_LOWER
}

export const isValidZip = (zip: string | null | undefined): boolean => {
  if (!zip) return true
  const zipRegex = /^\d{5}(-\d{4})?$/
  return zipRegex.test(zip)
}
